import React, { useState } from "react";
import {
  Box, Grid, Typography, Dialog, Select, MenuItem, InputAdornment, FormControl, InputLabel, IconButton, CircularProgress,
  Button,
  DialogContent,
  TextField
} from "@mui/material";

import "../home/home.style.css";
//import TabsCareTeamAndRecords from "./tabs_care_team_and_records";
//import Care_Teams from "./care_teams";
import CareTeams from "./care_teams";
import RecordsList from "./records_list";
//import ListItemButton from "@mui/material/ListItemButton";
import FileUploadIcon from "@mui/icons-material/FileUpload";
//import UploadDialog from "../shared/records/upload_dialog";
import { getApiUrl, getShareRecordUrl } from "../../services/api_service";
import CloseIcon from '@mui/icons-material/Close';
//import { useStyles } from "../../style";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { styled } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import AccessLocalStorage from "../../services/localStorage";
import { buttonRed, dashboardText, dialogEditEvent, icon34, lightcolor, mainGrid, paddingbox, pcolor, pointer, rcolor, scrollMargin, uploadiconborder, whitecolor } from "../../style2";
//import { ListItem } from "@mui/material";


function Care_Team_Records(props) {
  const [openUploadDialog, setOpenUploadDialog] = React.useState(false);
  const [sharedRecordChanged, setSharedRecordChanged] = useState(null);
  const handleOpenUploadDialog = () => {
    setOpenUploadDialog(true);
  };

  const handleCloseUploadDialog = () => {
    setOpenUploadDialog(false);
  };


  return (
    <Box>
      <Box sx={paddingbox}>
        <Box mb={2}></Box>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} sx={{ ...dashboardText, ...scrollMargin }} id={props.id[1]}>
            <Box display="flex" alignItems="center" sx={{ ...dashboardText, color: pcolor }}>
              <Box component="img" src="assets/patient.png" sx={icon34}></Box>
              <Box mr={1} />
              Records
              <Grid container justifyContent="flex-end">
                <Box component="div">
                  <Button onClick={handleOpenUploadDialog} tabIndex={-1}
                    startIcon={<FileUploadIcon />}
                    sx={{ backgroundColor: rcolor, borderRadius: "5px", color: whitecolor, fontWeight: "normal", fontSize: "15px" }}>
                    Share Records
                  </Button>
                </Box>
              </Grid>
              <Box m={1} />
            </Box>
            <Box sx={{ ...mainGrid, marginTop: "10px", padding: "20px 30px 20px 30px" }}>
              <Box sx={{ padding: "0px 15px" }}>
                <RecordsList sharedrecordreload={sharedRecordChanged} />
              </Box>
              <Box m={2} />
            </Box>
          </Grid>
          <Box m={2} />
          <Grid item xs={12} sm={12} sx={{ ...dashboardText, ...scrollMargin }} id={props.id[0]}>
            <CareTeams />
          </Grid>
        </Grid>
        <Box m={2} />
      </Box>
      {openUploadDialog ? <RecordUploadFile onClose={handleCloseUploadDialog} onSaved={() => { setSharedRecordChanged(Date.now()); handleCloseUploadDialog(); }} /> : null}
    </Box>
  );
}
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});
function RecordUploadFile({ onClose, onSaved }) {
  //const classes = useStyles();
  const [attachments, setAttachments] = useState([]);
  const [date, setDate] = useState(Date.now());
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const maxFileUploadATime = 4;
  const ls = new AccessLocalStorage();
  const [loading, setLoading] = useState(false);

  const saveAttachments = () => {
    if (attachments === null || attachments.length === 0) {
      setError("Please upload some files.");
      return;
    }
    else {
      let validext = ".jpg,.jpeg,.png,.mp3,.mp4,.pdf,.doc,.docx";
      for (let k = 0; k < attachments.length; k++) {
        if (validext.indexOf(attachments[k].ext) === -1) {
          setError("Invalid file format, please upload in jpg, jpeg, png, mp3, mp4, pdf, doc and docx formats.");
          return;
        }
      }
    }
    const fd = new FormData();
    for (let k = 0; k < attachments.length; k++) {
      fd.append(`Files[${k}].File`, attachments[k].file);
      fd.append(`Files[${k}].Name`, `${encodeURIComponent(attachments[k].name)}.${attachments[k].ext}`);
      fd.append(`Files[${k}].DocumentType`, attachments[k].documentType);
    }

    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
    }
    if (!token) {
      setError("Unauthorized. No token available.");
      setLoading(false);
      return;
    }
    setLoading(true);
    setError("");
    setSuccess("");
    let url = `${getApiUrl()}/Record/upload/${ls.getCurrentPatientId()}`;
    fetch(url,
      {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: fd
      }
    )
      .then((response) => {
        if (response.status === 200) {
          setAttachments([]);
          setError("");
          setSuccess("Record shared successfully");
          setTimeout(() => { onSaved(); }, 1500);

        }
        else {
          response.json().then(data => {
            setError(data.error);
          }).catch(err => {
            setError(err.message || "An error occurred.");
            console.log(err);
          });
        }
      })
      .catch((err) => { setError(err.message || "An error occurred."); console.log(err); })
      .finally(() => { setLoading(false); });
  }

  return <Dialog open={true} onClose={onClose} maxWidth="md" fullWidth>
    <Box sx={{ ...dialogEditEvent, backgroundColor: lightcolor, border: "1px solid #D9D9D9" }}>
      <Grid container xs={12} align="center" sx={{ textAlign: "left" }}>
        <Grid item xs={11}>
          <Typography sx={{ color: pcolor, fontWeight: "bold", fontSize: "20px", textTransform: "capitalize" }}>
            Health and Social Care Records Upload
          </Typography>
        </Grid>
        <Grid item xs={1} sx={{ color: rcolor, textAlign: "right", ...pointer }}>
          <CloseIcon onClick={onClose} sx={{ width: "35px", height: "35px" }} />
        </Grid>
      </Grid>
      <DialogContent sx={{ padding: "5px" }}>

        <Box sx={{ backgroundColor: whitecolor, padding: "8px 15px", marginBottom: "20px", borderRadius: "15px", marginTop: "10px", marginBottom: "10px" }}>
          <Grid container xs={12}>
            <Grid item xs={6}>
              <Typography sx={{ marginTop: "10px", color: "rgb(113, 115, 134)" }}>Record file of size 50 MB max is allowed.</Typography>
            </Grid>
            <Grid item xs={6} sx={{ textAlign: "center" }}>
              <Button disabled={loading} color="primary" size="large" sx={{ backgroundColor: rcolor, borderRadius: "15px", marginTop: "10px" }} component="label" role={undefined} variant="contained" tabIndex={-1} startIcon={<CloudUploadIcon />}> Upload file
                <VisuallyHiddenInput multiple={true} type="file" accept=".jpg, .png, .doc, .docx, .jpeg, .pdf, .mov, .mp3, .mp4" onChange={(e) => {
                  let temp = attachments;
                  for (let k = 0; k < e.target.files.length; k++) {
                    if (temp.length < maxFileUploadATime) {
                      temp.push({
                        file: e.target.files[k],
                        name: e.target.files[k].name.split('.').shift(),
                        ext: e.target.files[k].name.split('.').pop(),
                        documentType: 1
                      });
                    } else
                      break;
                  }
                  setAttachments(temp);
                  setDate(Date.now());
                  setError("");
                }} />
              </Button>
            </Grid>
            <Grid item xs={12} sx={{ marginTop: 5, marginBottom: 5 }}>
              {/* <LinearProgress variant="determinate" value={(attachments.length/maxFileUploadATime) * 100} /> */}
              <Typography sx={{ fontSize: "14px" }}>Uploaded Documents: (<strong>{attachments.length}</strong>/{maxFileUploadATime})</Typography>
            </Grid>
          </Grid>
        </Box>

        <div>
          {attachments.map((item, index) => {
            return <Box style={{ padding: "8px", marginTop: "10px", backgroundColor: "#ffffff", paddingTop: '20px', borderRadius: "15px" }} data-date={date}>
              <Grid container xs={12}>
                <Grid item xs={6}>
                  <TextField disabled={loading} error={item.name === ""} helperText={item.name === "" ? "Required" : ""} label="File Name" variant="outlined" fullWidth value={item.name} onChange={(e) => {
                    attachments[index].name = e.target.value;
                    setAttachments(attachments);
                    setDate(Date.now());
                  }} InputProps={{
                    endAdornment: <InputAdornment position="start">.{item.ext}</InputAdornment>,
                    maxLength: 200
                  }} />
                </Grid>
                <Grid item xs={5} pl={1}>
                  <FormControl fullWidth>
                    <InputLabel id={`record-type-label-${index}`}>Record Type</InputLabel>
                    <Select disabled={loading} label="Record Type" value={item.documentType} onChange={(e) => {
                      attachments[index].documentType = e.target.value;
                      setAttachments(attachments);
                      setDate(Date.now());
                    }}>
                      <MenuItem value={1}>Record</MenuItem>
                      <MenuItem value={2}>Management Plan</MenuItem>
                    </Select>
                  </FormControl>

                </Grid>
                <Grid item xs={1} style={{ textAlign: "right" }}>
                  <IconButton disabled={loading} aria-label="delete" onClick={() => {
                    let temp = attachments;
                    temp.splice(index, 1);
                    setAttachments(temp);
                    setDate(Date.now());
                  }}>
                    <DeleteIcon />
                  </IconButton>
                </Grid>
              </Grid>

            </Box>
          })}
          {error !== "" ? <Box style={{ textAlign: "center", color: "red", padding: "4px" }}>{error}</Box> : null}
          {success !== "" ? <Box style={{ textAlign: "center", color: "green", padding: "4px" }}>{success}</Box> : null}
        </div>
        {attachments.length > 0 ? <Box sx={{ padding: "8x", marginTop: "10px", textAlign: "center" }}>
          {loading ? <CircularProgress color="success" /> : <Button type="button" disabled={loading} sx={buttonRed} onClick={() => {
            saveAttachments()
          }}>Submit &amp; Share</Button>}
        </Box> : null}

      </DialogContent>
    </Box>
  </Dialog>;
}

export default Care_Team_Records;
